import { Phone } from "lucide-react";
import { PHONE } from "@/lib/constants";

export default function Navbar() {
  return (
    <header data-testid="site-navbar" className="sticky top-0 z-50 bg-[#EBEBFA]/90 backdrop-blur-md border-b border-[#1A243B]/10">
      <div className="max-w-6xl mx-auto px-6 md:px-10 h-16 flex items-center justify-between">
        <a href="#top" data-testid="nav-brand" className="font-display font-bold text-lg text-[#1A243B] tracking-tight">
          Ready <span className="italic">&amp;</span> Right
        </a>
        <nav className="hidden md:flex items-center gap-8 text-sm font-semibold text-[#2D3748]">
          <a data-testid="nav-services-link" href="#services" className="hover:text-[#1A243B] transition-colors">Services</a>
          <a data-testid="nav-faq-link" href="#faqs" className="hover:text-[#1A243B] transition-colors">FAQs</a>
          <a data-testid="nav-contact-link" href="#contact" className="hover:text-[#1A243B] transition-colors">Contact</a>
        </nav>
        <div className="flex items-center gap-3">
          <a data-testid="nav-phone-link" href={`tel:${PHONE.replace(/-/g, "")}`} className="hidden sm:flex items-center gap-2 text-sm font-semibold text-[#1A243B] hover:opacity-70 transition-opacity">
            <Phone className="w-4 h-4" /> {PHONE}
          </a>
          <a data-testid="nav-book-btn" href="#book" className="cta-pill inline-block bg-[#FFC107] text-[#1A243B] text-sm font-bold px-5 py-2.5 rounded-full">
            Book online
          </a>
        </div>
      </div>
    </header>
  );
}
